import { Injectable } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "src/environments/environment";
import { lastValueFrom } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SucursalService extends BaseService {
    
    override recordName = 'sucursales';

    override url = `${ environment.host }/sucursal`;

    async buscarSucursal( body?: Record<string, any>) {      
        let url = `${this.url}/buscar-sucursal`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async controlarBloqueo( filtros: Record<string, any>) {      
        let url = `${this.url}/controlar-bloqueo`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  { filtros: filtros } , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
}